import { RolesForm } from 'pages/Roles/components/RolesForm/RolesForm';
import { RaRecord } from 'react-admin';
import { CancelButton, SaveButtonValidated } from 'shared/mui/Buttons';
import { CreateGuesserPage } from 'shared/react-admin/Pages/CreateGuesserPage/CreateGuesserPage';

const transform = ({ roleCategories, ...data }: RaRecord): RaRecord => ({
  ...data,
  roleCategories: Array.isArray(roleCategories) ? roleCategories[0] : roleCategories,
});

export const RolesCreate: React.FC = () => (
  <CreateGuesserPage
    listName="Роли"
    mutationOptions={{ onError: () => undefined }}
    rightActionsSlot={[
      <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
      <SaveButtonValidated key="save-button" />,
    ]}
    title="Cоздание роли"
    transform={transform}
  >
    <RolesForm />
  </CreateGuesserPage>
);
